import React from 'react'
import 'react-toastify/dist/ReactToastify.css'
import './Toast.scss'
import {
  FeedbackSent,
  UserUnfollow,
  UserFollow,
  WagerBuy,
  WagerSell,
  Deposit,
  PushNotification,
  MarketFollow,
  Success,
  Fail,
  InfoToast,
} from '@/features/notifications/components/message-types'

const Toast = ({ component, _data }) => {
  const from = typeString => {
    switch (typeString) {
      case 'wagerBuy':
        return <WagerBuy {..._data} />
      case 'wagerSell':
        return <WagerSell {..._data} />
      case 'feedbackSent':
        return <FeedbackSent {..._data} />
      case 'userFollow':
        return <UserFollow {..._data} />
      case 'deposit':
        return <Deposit {..._data} />
      case 'success':
        return <Success {..._data} />
      case 'fail':
      case 'error':
        return <Fail {..._data} />
      case 'userUnfollow':
        return <UserUnfollow {..._data} />
      case 'pushNotification':
        return <PushNotification {..._data} />
      case 'marketFollow':
        return <MarketFollow {..._data} />
      case 'info':
        return <InfoToast {..._data} />

      default:
        return <></>
    }
  }

  return from(component)
}

export default Toast
